import { PersonalDetailsReqRes } from 'src/app/account/models/personalDetailsReqRes.model';
import { CompanyProfileLpRequest } from '../lp-profile/company-profile-lp/companyProfileLpRequest.model';

export class OnboardingLpRequest {
  public personalDetails: PersonalDetailsReqRes;

  public organizationDetails: CompanyProfileLpRequest;
}
